import { RouteConfig } from 'vue-router'
import Main from '../Sensor/Main.vue'

export const sensorRoutes: RouteConfig = {
  path: '/sensor',
  name: 'sensor',
  component: Main
}
